import { render, staticRenderFns } from "./indonesia.vue?vue&type=template&id=fd3d7a4e&scoped=true"
import script from "./indonesia.vue?vue&type=script&lang=js"
export * from "./indonesia.vue?vue&type=script&lang=js"
import style0 from "./indonesia.vue?vue&type=style&index=0&id=fd3d7a4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3d7a4e",
  null
  
)

export default component.exports